import React from 'react';
import PropTypes from 'prop-types';
import ToggleIcon from '../../toggle-icon';

const StatusIcons = ({ emergencyStatusObject, handleOnChangeIcons, editMode }) => (
  <>
    <ToggleIcon
      key="has_power"
      imagePosition="Top"
      name={emergencyStatusObject.has_power ? 'Has Power' : 'No Power'}
      imageName="power"
      value="has_power"
      isActive={emergencyStatusObject.has_power}
      canToggle={editMode}
      iconHeight={40}
      iconWidth={40}
      isVertical
      showHasNoIcon
      handleOnClick={handleOnChangeIcons}
    />
    <ToggleIcon
      key="has_gas"
      imagePosition="Top"
      name={emergencyStatusObject.has_gas ? 'Has Gas' : 'No Gas'}
      imageName="gas"
      value="has_gas"
      isActive={emergencyStatusObject.has_gas}
      canToggle={editMode}
      iconHeight={40}
      iconWidth={40}
      isVertical
      showHasNoIcon
      handleOnClick={handleOnChangeIcons}
    />
    <ToggleIcon
      key="has_diesel"
      imagePosition="Top"
      name={emergencyStatusObject.has_diesel ? 'Has Diesel' : 'No Diesel'}
      imageName="diesel"
      value="has_diesel"
      isActive={emergencyStatusObject.has_diesel}
      canToggle={editMode}
      iconHeight={40}
      iconWidth={40}
      isVertical
      showHasNoIcon
      handleOnClick={handleOnChangeIcons}
    />
  </>
);

StatusIcons.propTypes = {
  emergencyStatusObject: PropTypes.shape({
    has_power: PropTypes.bool,
    has_gas: PropTypes.bool,
    has_diesel: PropTypes.bool,
  }).isRequired,
  handleOnChangeIcons: PropTypes.func,
  editMode: PropTypes.bool,
};

StatusIcons.defaultProps = {
  handleOnChangeIcons: undefined,
  editMode: false,
};

export default StatusIcons;
